<template>
  <CheckboxGroup
    v-model="data.value"
    :options="data.options"
    @change="bindChange"
  >
    <CheckboxItem
      v-for="(item, index) in data.options"
      :key="index"
      :value="item.key"
      :data="item"
    >
      <div>
        <div
          class="checkbox-text"
          :style="{
            background: data.value.includes(item.key)
              ? theme.checkColor
              : theme.notCheckColor
          }"
          v-if="item.value && !item.que_answer_icon"
          >{{ item.value }}</div
        >
        <div class="radio-image" v-if="item.que_answer_icon">
          <img style="width: 100%" :src="item.que_answer_icon" alt="" />
          <div
            class="active iconfont icon-gou"
            v-show="data.value == item.key"
            :style="{ background: theme.checkColor }"
          ></div>
        </div>
        <div
          v-if="item.que_answer_attr && data.value.includes(item.key)"
          class="raido-input"
          @click.stop
        >
          <van-field
            v-model="item.inputValue"
            rows="3"
            type="textarea"
            placeholder="请输入(选填)"
          />
        </div>
      </div>
    </CheckboxItem>
  </CheckboxGroup>
</template>
<script>
import CheckboxItem from './checkbox/checkbox.vue'
import CheckboxGroup from './checkbox/checkbox-group.vue'
import Bus from '@/utils/bus' // 引入事件总线
export default {
  components: {
    CheckboxGroup,
    CheckboxItem
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    theme: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    bindChange(value, changeValue) {
      this.autoScroll(value, changeValue)
      this.$emit('change', value)
    },
    autoScroll(value, changeValue) {
      this.data.options.map((item) => {
        if (
          changeValue === item.key &&
          value.includes(changeValue) &&
          item.que_answer_attr
        ) {
          //如果是其他选项，则滚动到最底下，避免看不到输入框
          this.$nextTick(() => {
            Bus.$emit('commonQuestionRadioSelectOther')
          })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.checkbox-text {
  padding: 14px 16px;
  border-radius: 8px;
  box-sizing: border-box;
}

.raido-input {
  margin-top: 10px;
  width: 100%;
  border: 1px solid #eee;
  box-sizing: border-box;
}

.radio-image {
  position: relative;

  .active {
    position: absolute;
    right: 24px;
    top: 50%;
    color: #fff;
    transform: translate(0%, -50%);
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #9f91fe;
    font-size: 12px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
